import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/AuthService/auth';
import { Role } from '../models/auth.dto';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoles = route.data['roles'] as Role[] | undefined;
    const role = this.auth.getSession()?.role;

    if (allowedRoles && role && allowedRoles.includes(role)) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
